(function () {
  'use strict';

  if (window.YuvienProductTransition) return;

  var MAIN_SELECTOR = '[data-yap-ajax-main]';
  var LINK_SELECTOR = '[data-yap-product-switch]';
  var activeRequest = null;
  var requestSerial = 0;
  var progressElement = null;
  var progressBar = null;
  var progressTimer = null;
  var progressHideTimer = null;
  var progressValue = 0;
  var progressStartedAt = 0;

  function currentMain() {
    return document.querySelector(MAIN_SELECTOR + ':not(.is-yap-ajax-staging)') ||
      document.querySelector(MAIN_SELECTOR);
  }

  function isPlainLeftClick(event, link) {
    return event.button === 0 && !event.defaultPrevented &&
      !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
      !link.hasAttribute('download') &&
      (!link.target || link.target === '_self');
  }

  function isProductUrl(url) {
    return url.origin === window.location.origin && /\/products\/[^/]+/.test(url.pathname);
  }

  function displayUrl(input) {
    var url = new URL(input, window.location.href);
    url.searchParams.delete('sections');
    url.searchParams.delete('section_id');
    return url;
  }

  function emit(target, name, detail) {
    target.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      detail: detail || {}
    }));
  }

  function setPending(main, busy) {
    if (!main) return;
    main.classList.toggle('is-yap-ajax-pending', busy);
    main.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function ensureProgress() {
    if (progressElement && document.documentElement.contains(progressElement)) return progressElement;

    progressElement = document.querySelector('[data-yap-ajax-progress]');
    if (!progressElement) {
      progressElement = document.createElement('div');
      progressElement.className = 'yap-ajax-progress';
      progressElement.setAttribute('data-yap-ajax-progress', '');
      progressElement.setAttribute('role', 'progressbar');
      progressElement.setAttribute('aria-label', 'Loading product');
      progressElement.setAttribute('aria-valuemin', '0');
      progressElement.setAttribute('aria-valuemax', '100');
      progressElement.setAttribute('aria-hidden', 'true');

      progressBar = document.createElement('span');
      progressBar.className = 'yap-ajax-progress__bar';
      progressElement.appendChild(progressBar);
      document.body.appendChild(progressElement);
    } else {
      progressBar = progressElement.querySelector('.yap-ajax-progress__bar');
    }
    return progressElement;
  }

  function renderProgress(value) {
    ensureProgress();
    progressValue = Math.max(progressValue, Math.min(1, value));
    if (progressBar) progressBar.style.transform = 'scaleX(' + progressValue + ')';
    progressElement.setAttribute('aria-valuenow', String(Math.round(progressValue * 100)));
  }

  function startProgress() {
    ensureProgress();
    clearInterval(progressTimer);
    clearTimeout(progressHideTimer);
    progressStartedAt = Date.now();

    var wasActive = progressElement.classList.contains('is-active');
    progressElement.classList.add('is-active');
    progressElement.setAttribute('aria-hidden', 'false');

    /* A new request can replace an in-flight one. Keep the existing progress in
       that case instead of jumping backwards; only reset after a completed load. */
    if (!wasActive) {
      progressValue = 0;
      if (progressBar) {
        progressBar.style.transition = 'none';
        progressBar.style.transform = 'scaleX(0)';
      }
      window.requestAnimationFrame(function () {
        if (progressBar) progressBar.style.transition = '';
        renderProgress(0.08);
      });
    } else {
      renderProgress(0.08);
    }

    progressTimer = window.setInterval(function () {
      var remaining = 0.9 - progressValue;
      if (remaining <= 0.01) return;
      renderProgress(progressValue + Math.max(0.008, remaining * 0.13));
    }, 220);
  }

  function finishProgress(immediate) {
    clearInterval(progressTimer);
    clearTimeout(progressHideTimer);
    progressTimer = null;
    if (!progressElement) return;

    if (immediate) {
      progressElement.classList.remove('is-active');
      progressElement.setAttribute('aria-hidden', 'true');
      progressValue = 0;
      if (progressBar) progressBar.style.transform = 'scaleX(0)';
      return;
    }

    renderProgress(1);
    progressHideTimer = window.setTimeout(function () {
      progressElement.classList.remove('is-active');
      progressElement.setAttribute('aria-hidden', 'true');
      progressHideTimer = window.setTimeout(function () {
        progressValue = 0;
        if (progressBar) {
          progressBar.style.transition = 'none';
          progressBar.style.transform = 'scaleX(0)';
          window.requestAnimationFrame(function () {
            if (progressBar) progressBar.style.transition = '';
          });
        }
      }, 120);
    }, 70);
  }

  function cleanupSection(sectionId, container) {
    if (container) emit(container, 'shopify:section:unload', { sectionId: sectionId });
    var cleanups = window.__YAP_SECTION_CLEANUPS__ || {};
    if (typeof cleanups[sectionId] === 'function') cleanups[sectionId]();
    document.body.style.overflow = '';
  }

  function parseSection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var main = doc.querySelector(MAIN_SELECTOR);
    if (!main) throw new Error('The rendered product section has no Ajax main container.');
    return main;
  }

  function scriptIsExecutable(script) {
    var type = (script.getAttribute('type') || '').trim().toLowerCase();
    return !type || type === 'text/javascript' || type === 'application/javascript' || type === 'module';
  }

  function activateScripts(container) {
    var scripts = Array.prototype.slice.call(container.querySelectorAll('script'))
      .filter(scriptIsExecutable);

    return scripts.reduce(function (chain, oldScript) {
      return chain.then(function () {
        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          Array.prototype.slice.call(oldScript.attributes).forEach(function (attribute) {
            script.setAttribute(attribute.name, attribute.value);
          });

          if (oldScript.src) {
            script.onload = resolve;
            script.onerror = reject;
          } else {
            script.textContent = oldScript.textContent;
          }

          oldScript.parentNode.replaceChild(script, oldScript);
          if (!script.src) resolve();
        });
      });
    }, Promise.resolve());
  }

  function ensureMeta(attribute, key, value) {
    var selector = 'meta[' + attribute + '="' + key + '"]';
    var nodes = Array.prototype.slice.call(document.head.querySelectorAll(selector));
    var node = nodes.shift();

    if (value === null || value === undefined || value === '') {
      if (node) node.remove();
      nodes.forEach(function (extra) { extra.remove(); });
      return;
    }

    if (!node) {
      node = document.createElement('meta');
      node.setAttribute(attribute, key);
      document.head.appendChild(node);
    }
    node.setAttribute('content', String(value));
    nodes.forEach(function (extra) { extra.remove(); });
  }

  function syncSeo(main) {
    var payload = main.querySelector('[data-yap-ajax-seo]');
    if (!payload) throw new Error('The rendered product section has no SEO payload.');

    var seo = JSON.parse(payload.textContent);
    var og = seo.og || {};

    document.title = seo.title || document.title;
    ensureMeta('name', 'description', seo.description);

    var canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = seo.canonical || seo.productUrl || window.location.href;

    ensureMeta('property', 'og:url', og.url || seo.canonical);
    ensureMeta('property', 'og:title', og.title);
    ensureMeta('property', 'og:type', og.type || 'product');
    ensureMeta('property', 'og:description', og.description || seo.description);
    ensureMeta('property', 'og:price:amount', og.priceAmount);
    ensureMeta('property', 'og:price:currency', og.priceCurrency);
    ensureMeta('property', 'og:image', og.image);
    ensureMeta('property', 'og:image:secure_url', og.image);
    ensureMeta('property', 'og:image:width', og.imageWidth);
    ensureMeta('property', 'og:image:height', og.imageHeight);
    ensureMeta('name', 'twitter:title', og.title);
    ensureMeta('name', 'twitter:description', og.description || seo.description);

    return seo;
  }

  function reinitialize(main, sectionId, seo) {
    return activateScripts(main).then(function () {
      if (window.Shopify && window.Shopify.PaymentButton &&
          typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }

      var sectionContainer = main.closest('.shopify-section') || main;
      emit(sectionContainer, 'shopify:section:load', { sectionId: sectionId });
      emit(main, 'yap:product:loaded', {
        sectionId: sectionId,
        productId: seo.productId,
        handle: seo.handle,
        url: window.location.href
      });
      document.dispatchEvent(new CustomEvent('product:changed', {
        detail: {
          sectionId: sectionId,
          productId: seo.productId,
          handle: seo.handle,
          url: window.location.href
        }
      }));
    });
  }

  function afterNextPaint() {
    return new Promise(function (resolve) {
      var raf = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
      raf(function () { raf(resolve); });
    });
  }

  function waitForImage(image, timeout) {
    if (!image) return Promise.resolve();

    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(finish, timeout);

      function cleanup() {
        image.removeEventListener('load', onReady);
        image.removeEventListener('error', finish);
        window.clearTimeout(timer);
      }

      function finish() {
        if (settled) return;
        settled = true;
        cleanup();
        resolve();
      }

      function onReady() {
        if (typeof image.decode === 'function') {
          image.decode().then(finish, finish);
        } else {
          finish();
        }
      }

      if (image.complete) {
        onReady();
      } else {
        image.addEventListener('load', onReady, { once: true });
        image.addEventListener('error', finish, { once: true });
      }
    });
  }

  function waitForVisualReady(main) {
    var primaryImage = main.querySelector('[data-yap-stage] .yap-slide img') ||
      main.querySelector('[data-yap-gallery] img');

    /* Image decoding can fail or stall on a broken asset, so never hold the
       transition indefinitely. Two animation frames ensure the decoded image and
       the newly initialized section have actually reached the screen. */
    return waitForImage(primaryImage, 1600).then(afterNextPaint);
  }

  function waitForProgressMinimum(duration) {
    var remaining = duration - (Date.now() - progressStartedAt);
    if (remaining <= 0) return Promise.resolve();
    return new Promise(function (resolve) { window.setTimeout(resolve, remaining); });
  }

  function requestSection(url, sectionId, signal) {
    var requestUrl = new URL(url.toString());
    requestUrl.hash = '';
    requestUrl.searchParams.set('sections', sectionId);

    return fetch(requestUrl.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Product section request failed: HTTP ' + response.status);
      return response.json();
    }).then(function (sections) {
      var html = sections && sections[sectionId];
      if (!html) throw new Error('Shopify returned a null product section.');
      return html;
    });
  }

  function navigate(input, options) {
    options = options || {};
    var main = currentMain();
    if (!main) {
      window.location.assign(displayUrl(input).toString());
      return Promise.resolve(false);
    }

    var url = displayUrl(input);
    var sectionId = main.getAttribute('data-section-id');
    if (!sectionId || !isProductUrl(url)) {
      window.location.assign(url.toString());
      return Promise.resolve(false);
    }

    if (options.push) {
      window.history.pushState({ yapAjaxProduct: true }, '', url.pathname + url.search + url.hash);
    }

    if (activeRequest) activeRequest.abort();
    activeRequest = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var serial = ++requestSerial;
    var stagedMain = null;

    startProgress();
    setPending(main, true);
    emit(main, 'yap:product:before-load', { sectionId: sectionId, url: url.toString() });

    return requestSection(url, sectionId, activeRequest ? activeRequest.signal : undefined)
      .then(function (html) {
        if (serial !== requestSerial) return false;
        renderProgress(0.48);

        var parsedMain = parseSection(html);
        var nextMain = document.importNode(parsedMain, true);
        var seo = syncSeo(nextMain);
        var sectionContainer = main.closest('.shopify-section') || main;
        renderProgress(0.7);

        cleanupSection(sectionId, sectionContainer);
        nextMain.classList.add('is-yap-ajax-staging');
        nextMain.setAttribute('aria-hidden', 'true');
        nextMain.setAttribute('aria-busy', 'true');
        main.before(nextMain);
        stagedMain = nextMain;
        renderProgress(0.84);

        return reinitialize(nextMain, sectionId, seo).then(function () {
          renderProgress(0.92);
          return Promise.all([
            waitForVisualReady(nextMain),
            waitForProgressMinimum(320)
          ]);
        }).then(function () {
          if (serial !== requestSerial) return false;
          renderProgress(0.98);
          main.remove();
          nextMain.classList.remove('is-yap-ajax-staging');
          nextMain.removeAttribute('aria-hidden');
          setPending(nextMain, false);
          stagedMain = null;
          return afterNextPaint();
        }).then(function () {
          if (serial !== requestSerial) return false;
          var heading = nextMain.querySelector('h1');
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
          }
          return true;
        });
      })
      .catch(function (error) {
        if (stagedMain && stagedMain.parentNode) stagedMain.remove();
        if (error && error.name === 'AbortError') return false;
        if (serial === requestSerial) setPending(main, false);
        console.error('[Yuvien product transition]', error);
        window.location.assign(url.toString());
        return false;
      })
      .then(function (result) {
        if (serial === requestSerial) {
          activeRequest = null;
          finishProgress(false);
        }
        return result;
      });
  }

  function onClick(event) {
    var link = event.target.closest && event.target.closest(LINK_SELECTOR);
    if (!link || !link.closest(MAIN_SELECTOR) || !isPlainLeftClick(event, link)) return;

    var url;
    try { url = displayUrl(link.href); } catch (error) { return; }
    if (!isProductUrl(url)) return;

    event.preventDefault();
    navigate(url, { push: true });
  }

  function onPopState() {
    var url = displayUrl(window.location.href);
    if (!isProductUrl(url) || !currentMain()) return;
    navigate(url, { push: false, popstate: true });
  }

  function onSectionUnload(event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    var cleanups = window.__YAP_SECTION_CLEANUPS__ || {};
    if (typeof cleanups[sectionId] === 'function') cleanups[sectionId]();
  }

  function onSectionLoad(event) {
    var container = event.target;
    var main = container.matches && container.matches(MAIN_SELECTOR)
      ? container
      : container.querySelector && container.querySelector(MAIN_SELECTOR);
    if (!main || main.querySelector('[data-yap-initialized="true"]')) return;
    activateScripts(main).then(function () {
      if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
    });
  }

  document.addEventListener('click', onClick);
  window.addEventListener('popstate', onPopState);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  document.addEventListener('shopify:section:load', onSectionLoad);

  if (currentMain()) {
    window.history.replaceState(
      Object.assign({}, window.history.state || {}, { yapAjaxProduct: true }),
      '',
      window.location.href
    );
  }

  window.YuvienProductTransition = {
    navigate: navigate,
    destroy: function () {
      if (activeRequest) activeRequest.abort();
      requestSerial += 1;
      activeRequest = null;
      finishProgress(true);
      document.removeEventListener('click', onClick);
      window.removeEventListener('popstate', onPopState);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      document.removeEventListener('shopify:section:load', onSectionLoad);
    }
  };
})();
